import { translateKeys } from './translateKeys';

/**
 * Convert a string from camelCase to snake_case
 */
export const snakeCase = (camelCasedString: string) =>
  camelCasedString.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

/**
 * Recursively convert all keys in an object from camelCase to snake_case
 */
export const deepSnakeCase = (objWithCamelCaseKeys: any): unknown => translateKeys(snakeCase, objWithCamelCaseKeys);
